<template>
  <div
    v-if="brand.features.showHelpDashboard"
    class="help"
    @click="goToWhatsapp()"
    :style="{ backgroundColor: $vuetify.theme.themes.light.tertiary }"
  >
    <div class="my-auto">
      <v-img class="mx-2" src="@/assets/icon-support.png" max-width="100" width="70px" contain></v-img>
    </div>
    <div class="d-flex flex-column justify-center">
      <div class="help-title">
        Precisa de ajuda?
      </div>
      <div class="help-text">
        Dúvidas sobre o aplicativo, funcionalidades, ou sobre como podemos te ajudar?
      </div>
    </div>
  </div>
</template>

<script>
import brandMixin from '@/mixins/brandMixin'

export default {
  name: 'HelpDashboard',
  mixins: [brandMixin],
  methods: {
    goToWhatsapp() {
      window.open('https://wa.me/5519986063327', '_blank')
    },
  },
}
</script>

<style scoped>
.help {
  display: flex;
  flex-direction: row;
  border-radius: 10px;
  background-color: #e7e9fc;
  padding: 10px;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  height: 110px;
}
.help-title {
  color: #7f7f7f !important;
  font-weight: 700;
  font-size: 1rem;
  text-decoration: none !important;
}
.help-text {
  color: #7f7f7f !important;
  font-weight: 400;
  font-size: 0.7rem !important;
  margin-top: 5px;
}

@media only screen and (min-width: 960px) {
  .help-text {
    font-size: 0.8rem !important;
  }
}
</style>
